type Props = {
  iconUrl?: string;
  alt: string;
  className?: string;
};

export const SsoProviderLogo = ({
  iconUrl,
  alt,
  className = 'h-6 w-6 object-contain'
}: Props) => {
  if (iconUrl) {
    return (
      <img
        src={iconUrl}
        alt={alt}
        className={className}
        loading='lazy'
        decoding='async'
      />
    );
  }

  const initial = (alt.trim().charAt(0) || '?').toUpperCase();

  return (
    <span
      aria-hidden
      className={`flex items-center justify-center rounded-full bg-accent-light-blue text-sm font-bold text-primary-blue ${className}`}>
      {initial}
    </span>
  );
};
